export enum AdminRole {
  SUPER_ADMIN = "super-admin",
  ADMIN = "admin",
  VETTING_ADMIN = "vetting-admin",
}
export enum AdminStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
}
export type Admin = {
  id: string;
  email: string;
  role: AdminRole;
  status: AdminStatus;
  isPasswordChangeRequired: boolean;
  createdAt: string;
  phoneNumber?: string;
  fullName?: string;
};
